import React from 'react';
import BusComponent from '../../BusComponent';

import DotDensityLegendItems from './DotDensityLegendItems';
import DotDensitySlider from './DotDensitySlider';


class DotDensityLegend extends BusComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dotSizeSliderValue: props.mapInstance.dataTheme.dotDensityValueHint,
        };
    }

    onDotSizeChange = value => {
        const { mapInstance } = this.props;

        this.emit('APPLY_DOT_VALUE_HINT_REQUEST', {
            mapInstanceId: mapInstance.id,
            dotDensityDotValueHint: value
        });
        this.setState({ dotSizeSliderValue: value });
    }

    render() {
        const { mapInstance } = this.props;
        const { dotSizeSliderValue } = this.state;

        return (<div className="dot-density-legend flex-it column">
            <DotDensitySlider
                renderer={mapInstance.dataTheme.rendering[0]}
                value={dotSizeSliderValue}
                onChange={this.onDotSizeChange}
            />
            <DotDensityLegendItems
                renderer={mapInstance.dataTheme.rendering[0]}
                isMultiVariable={mapInstance.dataTheme.variableSelection.isMultiVariable}
            />
        </div>);
    }
}

export default DotDensityLegend;
